import { LAYOUT } from '@admin/router/constant'

// 分拣机
const sortingMachineRouter = {
  path: '/sortingMachine',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/wms/sortingMachine/home',
      name: 'WMSSortingMachineHome',
      component: () => import('@admin/views/wms/sortingMachine/home/index.vue'),
      meta: { title: '分拣作业(分拣机)' },
    },
    {
      path: '/wms/sortingMachine/details',
      name: 'WMSSortingMachineDetails',
      component: () => import('@admin/views/wms/sortingMachine/details/index.vue'),
      meta: { title: '分拣作业(查看)' },
    },
  ],
}

export default [sortingMachineRouter]
